import { Component, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlatformModule } from '@app/platform.module';
import { FeatureService } from '@app/services/feature.service';
import { TranslateModule } from '@ngx-translate/core';
import { from } from 'rxjs';

@Component({
    selector: 'app-tax-form-consent-dialog',
    templateUrl: './tax-form-consent-dialog.template.html',
    styles: [
        `
            .consent {
                display: flex;
                gap: 0.5rem;
            }
        `,
    ],
    standalone: true,
    imports: [PlatformModule, TranslateModule, FormsModule, ReactiveFormsModule],
})
export class TaxFormConsentDialog {
    packageTypeToBeEmailed = input<'T4' | 'RL1' | 'ALL'>('T4');
    /**
     * If an employeeName is provided it is assumed that a single document is being sent to one employee
     * This will change the copy provided in the dialog
     */
    employeeName = input<string>();

    hasTaxFormsConsentFeatureFlag = toSignal(from(this.featureService.has('email-tax-forms-consent')));
    hasProvidedConsent = signal<boolean>(false);

    private _isOpen = false;
    private resolve?: (value: boolean | PromiseLike<boolean>) => void;

    get isOpen(): boolean {
        return this._isOpen;
    }

    constructor(private featureService: FeatureService) {}

    openDialog(): Promise<boolean> {
        return new Promise((resolve) => {
            this._isOpen = true;
            this.resolve = resolve;
        });
    }

    closeDialog({ isConfirmed }: { isConfirmed: boolean }): void {
        this.resolve?.(isConfirmed);
        this.hasProvidedConsent.set(false);
        this._isOpen = false;
    }
}
